import React, { useState } from 'react';
import UsersPanel from './UsersPanel';
import AllowListPanel from './AllowListPanel';
import McpAppsPanel from './McpAppsPanel';
import HorizonInstancesPanel from './HorizonInstancesPanel';
import RetentionPanel from './RetentionPanel';

type SettingsTab = 'users' | 'allowlist' | 'mcp' | 'horizon' | 'retention';

const SettingsPage: React.FC = () => {
  const [tab, setTab] = useState<SettingsTab>('users');

  return (
    <div className="settings-container">
      <nav className="settings-subnav">
        <button className={`nav-button ${tab === 'users' ? 'active' : ''}`} onClick={() => setTab('users')}>
          Users
        </button>
        <button className={`nav-button ${tab === 'allowlist' ? 'active' : ''}`} onClick={() => setTab('allowlist')}>
          SIP/RTP Allowlist
        </button>
        <button className={`nav-button ${tab === 'mcp' ? 'active' : ''}`} onClick={() => setTab('mcp')}>
          MCP Apps
        </button>
        <button className={`nav-button ${tab === 'horizon' ? 'active' : ''}`} onClick={() => setTab('horizon')}>
          Horizon Instances
        </button>
        <button className={`nav-button ${tab === 'retention' ? 'active' : ''}`} onClick={() => setTab('retention')}>
          Retention
        </button>
      </nav>

      {tab === 'users' && <UsersPanel />}
      {tab === 'allowlist' && <AllowListPanel />}
      {tab === 'mcp' && <McpAppsPanel />}
      {tab === 'horizon' && <HorizonInstancesPanel />}
      {tab === 'retention' && <RetentionPanel />}
    </div>
  );
};

export default SettingsPage;
